import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.cv{min-width:100%;}.ssr-plugin'
import '.cw{min-height:100vh;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.r{flex:1;}.ssr-plugin'
import '.cx{max-width:1280px;}.ssr-plugin'
import { Style, styled } from 'inlines'
import React, { ReactElement, ReactNode } from 'react'

type SectionProps = {
  children: ReactNode
  'aria-label'?: string
  style?: Style
}

type LayoutProps = {
  children: ReactNode
  style?: Style
}

export type LayoutCompound = {
  Navbar: React.FC<{ children: ReactNode }>
  Top: React.FC<SectionProps>
  Middle: React.FC<SectionProps>
  Bottom: React.FC<SectionProps>
  Footer: React.FC<{ children: ReactNode; style?: Style }>
}

export const Layout: React.FC<LayoutProps> & LayoutCompound = ({
  children,
  style,
}) => {
  const allChildren = React.Children.toArray(children) as ReactElement[]

  const navbar = allChildren.find(
    (child) => React.isValidElement(child) && child.type === Layout.Navbar,
  )
  const top = allChildren.find(
    (child) => React.isValidElement(child) && child.type === Layout.Top,
  )
  const middle = allChildren.find(
    (child) => React.isValidElement(child) && child.type === Layout.Middle,
  )
  const bottom = allChildren.find(
    (child) => React.isValidElement(child) && child.type === Layout.Bottom,
  )
  const footer = allChildren.find(
    (child) => React.isValidElement(child) && child.type === Layout.Footer,
  )

  if (!navbar || !middle || !footer) {
    throw new Error(
      '[Layout] You must use Layout.Navbar/Middle/Footer as children.',
    )
  }

  const topLabel = top?.props['aria-label'] ?? 'Top section'
  const middleLabel = middle?.props['aria-label'] ?? 'Main section'
  const bottomLabel = bottom?.props['aria-label'] ?? 'Bottom section'

  return (
    <div className="a i cv cw"
    >
      <header className="f" role="banner">
        {navbar.props.children}
      </header>

      <styled.main className="a c d i r f"
        style={{
          ...style,
        }}
      >
        {top && (
          <styled.section className="f cx a"
            aria-label={topLabel}
            style={{
              ...top.props?.style,
            }}
          >
            {top.props?.children}
          </styled.section>
        )}

        <styled.section className="f cx a"
          aria-label={middleLabel}
          style={{
            ...middle.props?.style,
          }}
        >
          {middle.props?.children}
        </styled.section>

        {bottom && (
          <styled.section className="f cx a"
            aria-label={bottomLabel}
            style={{
              ...bottom.props?.style,
            }}
          >
            {bottom.props?.children}
          </styled.section>
        )}
      </styled.main>

      <styled.footer className="f"
        role="contentinfo"
        style={{ ...footer.props.style }}
      >
        {footer.props.children}
      </styled.footer>
    </div>
  )
}

Layout.Navbar = ({ children }: { children: ReactNode }) => <>{children}</>
Layout.Top = ({ children }: SectionProps) => <>{children}</>
Layout.Middle = ({ children }: SectionProps) => <>{children}</>
Layout.Bottom = ({ children }: SectionProps) => <>{children}</>
Layout.Footer = ({ children }: { children: ReactNode; style?: Style }) => (
  <>{children}</>
)
